/**
 * Calculate the height of the dropdown based on the number of items.
 */
export function getHeight(numberOfItems: number) {
  const itemHeight = 40; // Height of each item in the dropdown
  const maxHeight = 150; // Maximum height of the dropdown
  const height = numberOfItems * itemHeight;
  return height > maxHeight ? `${maxHeight}px` : `${height}px`;
}
